import {CSSProperties, Fragment} from 'react'
import {StyledRadioStepLabel, StyledRadioStepsWrapper} from './style'
import {Divider} from '@/components/ui/divider/Divider'

export interface RadioStepsProps<T extends string | number = string> {
    name: string
    steps: Readonly<{label: string; value: T}[]>
    value?: T
    onChange?: (value: T) => void
    size?: 'sm' | 'md'
    inputType?: 'radio' | 'checkbox'
    itemWidth?: CSSProperties['width']
    fullWidth?: boolean
}

export const RadioSteps = <T extends string | number>({
    name,
    steps,
    value,
    onChange,
    size,
    itemWidth,
    inputType = 'radio',
    fullWidth = false
}: RadioStepsProps<T>) => {
    return (
        <StyledRadioStepsWrapper $fullWidth={fullWidth}>
            {steps.map((step, index) => (
                <Fragment key={index}>
                    <StyledRadioStepLabel
                        htmlFor={`${name}-${step.value}-${index}`}
                        $isSelected={value == step.value}
                        $size={size}
                        $itemWidth={itemWidth}
                    >
                        {step.label}
                    </StyledRadioStepLabel>
                    {index < steps.length - 1 && <Divider direction="vertical" height="auto" />}
                    <input
                        name={name}
                        id={`${name}-${step.value}-${index}`}
                        checked={step.value == value}
                        type={inputType}
                        onChange={() => onChange?.(step.value)}
                    />
                </Fragment>
            ))}
        </StyledRadioStepsWrapper>
    )
}
